import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AddProposalService } from '../../views/proposals/add-proposal/add-proposal.service';
import { Subject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { forEach } from 'jszip';
import { debug } from 'console';
import { title } from 'process';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-add-fields',
    templateUrl: './app-add-fields.component.html',
    styleUrls: ['./app-add-fields.component.css']
})
export class AddFieldsModule implements OnInit {
    private unsubscribe = new Subject<void>();
    field: string = '';
    description:string='';
    selectedServiceLine: any = '';
    selectedSLId: number;
    isNotValidField: boolean = false;
    isNotValidDescription:boolean=false;
    isCompetencySelected:boolean = false;
    isServiceLineSelected:boolean =false;
    ServiceLines :any=[];
    loading: boolean = false;
    selectedSubServiceLine: any='';
    competency:FormControl=new FormControl("",Validators.required)
    constructor(
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AddFieldsModule>,
        private toastr: ToastrService,
        private service: AddProposalService,
        private router: Router
    ) { }

    ngOnInit() {
        this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(event => {
            if (event instanceof NavigationStart) {
              this.dialogRef.close();
            }
          });
    }
    ngOnDestroy() {
    this.unsubscribe.next();
        this.unsubscribe.complete();
      }
    checkInput(event: string) {
        let serviceLine = this.data.data.find(i => i.toLowerCase() == event.toLowerCase());
        this.isNotValidField = serviceLine ? true : false;
    }
    checkTextAreaInput(event: string)
    {
        let serviceLine = this.data.data.find(i => i.toLowerCase() == event.toLowerCase());
        this.isNotValidDescription = serviceLine ? true : false;
    }
    addServiceLine() {
        if(this.competency.invalid)
            {
                this.competency.markAsTouched();
            }
       if((!this.isNotValidField && this.field)&&(!this.isNotValidDescription && this.description))
        {

            let data = {
                field: this.field,
                description:this.description,
            }
            this.dialogRef.close(data);

        }
        else if (!this.isNotValidField && this.field) {
            let data = {
                field: this.field,
                selectedCompId: this.selectedServiceLine,
                selectedSubCompId: this.selectedSubServiceLine
            }
            this.dialogRef.close(data);
        }
        else if((!this.isNotValidField && this.field)||this.isNotValidDescription&&this.description)
        {
            this.isNotValidDescription = true; 
            this.isNotValidField=false;
        }
        else if((!this.isNotValidDescription && this.description)||this.isNotValidField&&this.field)
        {
            this.isNotValidField= true; 
            this.isNotValidDescription=false
        }
        else {
            this.isNotValidField = true; 
            this.isNotValidDescription=true;
            if(this.selectedServiceLine=='')
            {
                this.isCompetencySelected = true;
            }
            if(this.selectedSubServiceLine == '')
            {
                this.isServiceLineSelected = true;
            }
        }
    }
     closeDialog(){
        this.dialogRef.close(false);
    }
    
    updateServieLine(event) {

        let id=event.value

        if(Number(id)>0){
            //   this.selectedSLId = this.data.serviceLine.indexOf(this.selectedServiceLine) + 1;
            this.loading = true;
            this.ServiceLines = []
            this.service.getServiceAreasById(id).subscribe((res) => {
                res.data.forEach(subComp=>{
                this.ServiceLines.push(subComp.name);
                this.loading = false;
                this.isCompetencySelected = false;
            })
            });
            
        }

        }
        disableError(event)
        {
            this.isServiceLineSelected = false;
        }

}
